import {useMemo} from 'react'
import {generatePath} from 'react-router-dom'
import {getAsset} from '@components/lib'

import routes from 'routes'
import {assetsConfig} from 'config/wallet/assetsConfig'

export default function useAssetLink(asset) {
  const assetInfo = getAsset(asset)
  return useMemo(() => {
    if (!assetsConfig.find(({id}) => id === asset)) {
      return routes.wallet.legacyWallets.path
    }
    return assetInfo?.urlId !== 'vime'
      ? generatePath(routes.wallet.info.path, {id: assetInfo?.urlId})
      : routes.wallet.path
  }, [asset, assetInfo?.urlId])
}
